import React from 'react';
import Chips from "../../Chips";
import Tooltip from "../../Tooltip";

import { isIPhone } from "@/modules/iOSDetection";
import {mouseOver, mouseLeave} from "@/modules/mouseInteractions";

import { assetImg } from "@/modules/moduleImporter";
import { IGameTableType } from "@/types/GlobalTypes";

import "./index.scss";
import { betGroupProp } from "@/modules/commonMobile";

//Monopoly & Monopoly World Cup
export default class M20 extends React.PureComponent<IGameTableType> {
	state = {activeHover: ""}
	
	render() {
		const { langdata, pcode } = this.props;
		
		const win = this.props.win || "";
		
		const largegroup = pcode === "m20" ?
			[
				[
					["indonesia", "singapore", "malaysia", "brunei"], //n4
					["japan", "china", "korea", "hongkong"], //n4
					["indonesia", "malaysia", "japan", "china", "macao", "india", "philippines", "laos"] //n8
				],
				[
					["cambodia", "macao", "india", "taiwan"], //n4
					["vietnam", "philippines", "thailand", "laos"], //n4
					["singapore", "brunei", "korea", "hongkong", "cambodia", "taiwan", "vietnam", "thailand"] //n8
				]
			] : pcode === "m21" ? [
				[
					["russia", "uruguay", "portugal", "spain"],
					["france", "denmark", "argentina", "croatia"],
					["russia", "portugal", "france", "denmark", "switzerland", "southkorea", "england", "japan"]
				],
				[
					["belgium", "england", "japan", "senegal"],
					["brazil", "switzerland", "germany", "southkorea"],
					["uruguay", "spain", "argentina", "croatia", "brazil", "germany", "belgium", "senegal"]
				]
			] : null;
		//13 12 23 24
		
		const topMobileGroups = [
				largegroup[0][0],
				largegroup[0][1],
				largegroup[1][0],
				largegroup[1][1]
		];

		const mobileColours = ["red", "yellow", "green", "blue"];

		const largeMobileGroups = [
				largegroup[0][2],
				largegroup[1][2]
			];
		
		const commonChipProps = {
			mobile: this.props.mobile,
			chipBase: this.props.chipBase,
			bets: this.props.bets,
			betOutOfBounds: this.props.betOutOfBounds
		};

		const commonTooltipProps = {
			langStr: langdata.language_code
		};

		return (
			this.props.portrait ?
			<div className="sl-table m20">
				<div className="row m20-n4">
				{
					topMobileGroups.map(group =>
						<div key={"m20_" + group}
							className={"sl-bet col-xs-6 m20-green-bg" + (group.indexOf(win) >= 0 ? " sl-yellow-alternating" : "")}
							{...betGroupProp(this, group.join(","), "n4")}
							// bet={group.join(",")} pcode={this.props.pcode} group="n4"
							onClick={this.props.insertBet}>
							{
								group.map(item =>
									assetImg(pcode, item, "portrait_m20_top_" + item)
								)
							}
							<div className="bet-type">1:2</div>
							<Chips {...commonChipProps} betKey={group.join(",") + "+n4"} />
						</div>
					)
				}
				</div>
				
				<div className="row m20-n50">
				{
					largeMobileGroups.map(group =>
						<div key={"m20_" + group}
							className={"sl-bet col-xs-6 m20-green-bg" + (group.indexOf(win) >= 0 ? " sl-yellow-alternating" : "")}
							{...betGroupProp(this, group.join(","), "n50")}
								//bet={group.join(",")} pcode={this.props.pcode} group="n50"
								onClick={this.props.insertBet}>
							{
								group.map((item, idx) => [
									// <img src={images[item]} alt={"m20_" + item} />,
									assetImg(pcode, item, "portrait_m20_large_" + item),
									(idx === 3 && <br />)
								])
							}
							<div className="bet-type">1:0.95 (50:50)</div>
							<Chips {...commonChipProps} betKey={group.join(",") + "+n50"} />
						</div>
					)
				}
				</div>
				
				<div className="row">
				{
					topMobileGroups.map((group, groupIdx) =>
						group.map((item) =>
							<div key={"m20_" + groupIdx + "_" + item} 
								className={"sl-bet col-xs-3 single sl-green-old m20-" + mobileColours[groupIdx] + "-border" + (win === item ? " sl-yellow-alternating" : "")}
								{...betGroupProp(this, item, "n")}
									// bet={item} pcode={this.props.pcode} group="n"
									onClick={this.props.insertBet}>
								{ assetImg(pcode, item) }
								<div>{item[0].toUpperCase() + item.substring(1)}</div>
								<div className="bet-type">1:11</div>
								<Chips {...commonChipProps} betKey={item + "+n"} />
							</div>
					))
				}
				</div>
			</div>
			
			
			: <div className="sl-table">
				<div className="m20-sides">
					<div className="bonus-text">X2 Bonus 1:2</div>
				{
					largegroup[1][0].map((item) =>
					/* ["cambodia", "macao", "india", "taiwan"] */
						<div key={`m20_sides_${item}`}
							className={"sl-bet" + 
								(this.props.maximised ? " sl-green-old" : " m20-green-new") +
								(this.state.activeHover.indexOf(item) >= 0 ? " sl-bet-hover" : "") +
								(win === item ? " sl-yellow-alternating" : "")}
							
							{...betGroupProp(this, item, "n")}
							// bet={item} pcode={this.props.pcode} group="n"
							onClick={this.props.insertBet}>
							
							{ this.props.maximised && [
								<div key={`m20_sides_${item}_0`} className="m20-green-new" />,
								<div key={`m20_sides_${item}_1`}>{item[0].toUpperCase() + item.substring(1)}</div>
								]
							}

							{ assetImg(pcode, item) }
							
							<div className="bet-type">1:11</div>
							<Chips {...commonChipProps} betKey={item + "+n"} />
							<Tooltip {...commonTooltipProps} bet={this.props.bets[item + "+n"]} />
						</div>
					)
				}
					<div className="bonus-text">X½ Bonus 1:0.5</div>
				</div>
				<div className="m20-middle">
					<div className="m20-top">
						{
							// ["indonesia", "singapore", "malaysia", "brunei"]
							largegroup[0][0].map((item) =>
								<div key={`m20_m_t_${item}`} className={"sl-bet" + 
									(this.props.maximised ? " sl-green-old" : " m20-red-pale") +
									(this.state.activeHover.indexOf(item) >= 0 ? " sl-bet-hover" : "") +
									(win === item ? " sl-yellow-alternating" : "")}
									{...betGroupProp(this, item, "n")}
									// bet={item} pcode={this.props.pcode} group="n"
									onClick={this.props.insertBet}>
									
									{ this.props.maximised && [
										<div key={`m20_m_t_${item}_0`} className="m20-red-pale" />, 
										<div key={`m20_m_t_${item}_1`}>{item[0].toUpperCase() + item.substring(1)}</div>
										] 
									}

									{
									// <img src={images[item]} alt={item} />
									}
									{ assetImg(pcode, item) }

									<div className="bet-type">1:11</div>
									<Chips {...commonChipProps} betKey={item + "+n"} />
									<Tooltip {...commonTooltipProps} bet={this.props.bets[item + "+n"]} />
								</div>
							)
						}
					</div>
					
					<div>
					{
						largegroup[0].map((group, idx) => {
							const grouptype = (idx === 2 ? "n50" : "n4");
							return (
								<div key={`m20_lg0_div_${idx}`}
									className={"sl-bet m20-green-pale" + (idx === 2 ? " m20-eight" : " m20-four") + (group.indexOf(win) >= 0 ? " sl-yellow-alternating" : "")}>
									{
										group.map((item) =>
											assetImg(pcode, item, `m20_lg0_img_${item}`)
										)
									}
									
									{
										group.length === 4 ?
										<div className="bet-type">1:2</div> :
										<div className="bet-type">1:0.95 (50:50)</div>
									}
									
									<Chips {...commonChipProps} betKey={group.join(",") + "+" + grouptype} />
									<Tooltip {...commonTooltipProps} bet={this.props.bets[group.join(",") + "+" + grouptype]} />
									<div className="sl-hover-hidden"
										{...betGroupProp(this, group.join(","), grouptype)}
										// bet={group.join(",")} pcode={this.props.pcode} group={grouptype}
										onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
								</div>);
						})
					}
					</div>
					<div>
					{
						largegroup[1].map((group, idx) => {
							const grouptype = (idx === 2 ? "n50" : "n4");
							return (
								<div key={`m20_lg0_div_${idx}`} 
									className={"sl-bet m20-green-pale" + (idx === 2 ? " m20-eight" : " m20-four") + (group.indexOf(win) >= 0 ? " sl-yellow-alternating" : "")}>
								{
									group.map((item) =>
										assetImg(pcode, item, `m20_lg1_${item}`)
									)
								}
								{
									group.length === 4 ?
									<div className="bet-type">1:2</div> :
									<div className="bet-type">1:0.95 (50:50)</div>
								}
								
								<Chips {...commonChipProps} betKey={group.join(",") + "+" + grouptype} />
								<Tooltip {...commonTooltipProps} bet={this.props.bets[group.join(",") + "+" + grouptype]} />
								<div className="sl-hover-hidden"
									{...betGroupProp(this, group.join(","), grouptype)}
									// bet={group.join(",")} pcode={this.props.pcode} group={grouptype}
									onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
								</div>
								);
						})
					}
					</div>
					
					
					<div className="m20-bottom">
						{
							// ["vietnam", "philippines", "thailand", "laos"]
							largegroup[1][1].map((item) =>
								<div key={`m20_b_${item}`} className={"sl-bet " +
									(this.props.maximised ? " sl-green-old" : " m20-blue-new") +
									(this.state.activeHover.indexOf(item) >= 0 ? " sl-bet-hover" : "") +
									(win === item ? " sl-yellow-alternating" : "")}
									{...betGroupProp(this, item, "n")}
									// bet={item} pcode={this.props.pcode} group="n"
									onClick={this.props.insertBet}>
									
									{ this.props.maximised && [
										<div key={`m20_b_${item}_0`} className="m20-blue-new" />, 
										<div key={`m20_b_${item}_1`}>{item[0].toUpperCase() + item.substring(1)}</div>
										] 
									}
									
									{ assetImg(pcode, item) }

									<div className="bet-type">1:11</div>
									<Chips {...commonChipProps} betKey={item + "+n"} />
									<Tooltip {...commonTooltipProps} bet={this.props.bets[item + "+n"]} />
								</div>
							)
						}
					</div>
				</div>
				<div className="m20-sides">
					<div className="bonus-text">X1 Bonus 1:1</div>
					{
						// ["japan", "china", "korea", "hongkong"]
						largegroup[0][1].map((item) =>
							<div key={`m20_sides_1_${item}`} className={"sl-bet" +
								(this.props.maximised ? " sl-green-old" : " m20-yellow-new") +
								(this.state.activeHover.indexOf(item) >= 0 ? " sl-bet-hover" : "") +
								(win === item ? " sl-yellow-alternating" : "")}
									{...betGroupProp(this, item, "n")}
									// bet={item} pcode={this.props.pcode} group="n"
									onClick={this.props.insertBet}>
								
								{ this.props.maximised && [
									<div key={`m20_sides_1_${item}_0`} className="m20-yellow-new" />,
									<div key={`m20_sides_1_${item}_1`}>{item[0].toUpperCase() + item.substring(1)}</div>
									] }
								
								{ assetImg(pcode, item) }
								
								<div className="bet-type">1:11</div>
								<Chips {...commonChipProps} betKey={item + "+n"} />
								<Tooltip {...commonTooltipProps} bet={this.props.bets[item + "+n"]} />
							</div>
						)
					}
					<div className="zonk-text">Zonk = Lose</div>
				</div>
			</div>
		);
	}
}
